import { components } from "react-select";

export const CustomDropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <i className="pi pi-chevron-down" style={{ fontSize: '16px', color: "#6c757d" }} />
  </components.DropdownIndicator>
);

export const CustomClearIndicator = (props) => (
  <components.ClearIndicator {...props}>
    <i className="pi pi-times" style={{ fontSize: '16px', color: "#6c757d" }} />
  </components.ClearIndicator>
);

// Exportando um preset para ser usado em qualquer Select
export const reactSelectIcons = {
  DropdownIndicator: CustomDropdownIndicator,
  ClearIndicator: CustomClearIndicator,
  IndicatorSeparator: () => null,
};
